import React from 'react';

const PaymentFailedNotification = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none">
      <rect width="28" height="28" fill="#FFEBEB" rx="14" />
      <mask
        id="a"
        width="16"
        height="16"
        x="6"
        y="6"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
      >
        <path fill="#D9D9D9" d="M6.22217 6.22266h15.5556v15.5556H6.22217z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#E92C2C"
          d="M14 20.4815c-.8966 0-1.7392-.1702-2.5277-.5107-.7886-.3401-1.47458-.8018-2.05791-1.3851-.58334-.5833-1.04503-1.2693-1.38509-2.0579-.3405-.7886-.51075-1.6312-.51075-2.5278 0-.8966.17025-1.7392.51075-2.5277.34006-.7886.80175-1.47458 1.38509-2.05791.58333-.58334 1.26931-1.04525 2.05791-1.38574.7885-.34006 1.6311-.5101 2.5277-.5101.8966 0 1.7392.17004 2.5278.5101.7886.34049 1.4746.8024 2.0579 1.38574.5833.58333 1.045 1.26931 1.3851 2.05791.3405.7885.5107 1.6311.5107 2.5277 0 .8966-.1702 1.7392-.5107 2.5278-.3401.7886-.8018 1.4746-1.3851 2.0579-.5833.5833-1.2693 1.045-2.0579 1.3851-.7886.3405-1.6312.5107-2.5278.5107Zm-.6481-5.8333h1.2963v-3.8889h-1.2963v3.8889ZM14 17.2408c.1837 0 .3377-.0622.4622-.1867.124-.124.186-.2778.186-.4615 0-.1836-.062-.3377-.186-.4621-.1245-.124-.2785-.186-.4622-.186-.1836 0-.3374.062-.4614.186-.1245.1244-.1867.2785-.1867.4621 0 .1837.0622.3375.1867.4615.124.1245.2778.1867.4614.1867Z"
        />
      </g>
    </svg>
  );
};

export default PaymentFailedNotification;
